import { render, staticRenderFns } from "./IndicadoresMarketplaceVendasSituacao.vue?vue&type=template&id=4fbd3291&scoped=true&"
import script from "./IndicadoresMarketplaceVendasSituacao.vue?vue&type=script&lang=js&"
export * from "./IndicadoresMarketplaceVendasSituacao.vue?vue&type=script&lang=js&"
import style0 from "./IndicadoresMarketplaceVendasSituacao.vue?vue&type=style&index=0&id=4fbd3291&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbd3291",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText,VCardTitle})
